import React from "react";
import { useSelector } from "react-redux";
import Table from "../../../components/table/coreUiTable/Table";
import { dataForStudioInfoTables, toPercent } from "../utils/dataForTables";

export const SalesActivityRevenueTable = () => {
  const tableInfo = useSelector((state) => state.studioInfo.salesActivityRevenue.tableInfo);
  const currency = useSelector((state) => state.commonReducer.commonProps.currencySymbol);

  const { scopedSlots, ...rest } = dataForStudioInfoTables(currency);

  return tableInfo.data.length > 0 ? (
    <Table
      table={tableInfo}
      {...rest}
      {...dataForStudioInfoTables(currency)}
      itemsPerPage={3}
      scopedSlots={{
        ...scopedSlots,
        "%": (item) => <td>{toPercent(item["%"])}</td>
      }}
    />
  ) : (
    <div className="error--medium">No revenue for selected date range</div>
  );
};
